export default "__VITE_ASSET__D8xQNM0G__"